export default {
    faq: {
        faq_detail: '상세',
    },
    'paygo.a11y.enabled': '켜짐',
    'paygo.a11y.disabled': '꺼짐',
    'paygo.a11y.labelAndroid': '{title}, 현재 상태는 {state}',
    'paygo.a11y.labelDefault': '{title}, {state}',
    'paygo.a11y.announceState': '{title}, {state}',
    'msgPush.tips': '알림',
    'msgPush.closePush': '알림을 끄면 프로모션 등 중요한 정보를 놓칠 수 있습니다.',
    'msgPush.confirm': '확인',
    'msgPush.cancel': '취소',
    'msgPush.appPush': '앱 푸시 알림',
    'msgPush.emailPush': '이메일 알림',
    'msgPush.loginFirst': '로그인하지 않았거나 세션이 만료되었습니다. 계속하려면 다시 로그인하세요.'
}



// WEBPACK FOOTER //
// ./src/lang/ko-KR.js